<template>
    <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
        <div v-show="show" class="inline-block align-bottom bg-white rounded-lg pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div :class="`mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-${$root.theme}-100`">
                    <i :class="`!text-2xl fa fa-info-circle fa-fw text-${$root.theme}-600`"></i>
<!--                    <svg :class="`h-8 w-8 text-${$root.theme}-600`" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">-->
<!--                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />-->
<!--                    </svg>-->
                </div>
                <div class="mt-2 text-center px-4">
                    <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                        Where is my CVV number?
                    </h3>
                    <img alt="find your cvv" src="/images/consumer/cvv.png" class="mt-3" />
                </div>
            </div>
            <div class="mt-5 sm:mt-6 px-4">
                <button @click="$emit('close')" type="button" :class="`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-${$root.theme}-400 text-base font-medium text-black hover:bg-${$root.theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${$root.theme}-300 sm:text-sm`">
                    Close
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['show'],

        computed: {
            template() {
                return window.find_reference_number;
            }
        }
    }
</script>
